import { Observable, of } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable, makeStateKey, TransferState } from '@angular/core';
import { Params } from '@angular/router';

import { PageViewModel as UmbracoPage, SearchResultCmsPageViewModel } from '@models/api.models';
import { map, tap } from 'rxjs/operators';
import { PlatformService } from '@core/services/platform.service';

const categoryNavigationStateKey = makeStateKey<UmbracoPage>('categoryNavigationStateKey');

@Injectable({
    providedIn: 'root'
})
export class ContentService {
    private contentCache: Record<string, SearchResultCmsPageViewModel[]> = {};

    constructor(
        private http: HttpClient,
        private transferState: TransferState,
        private platformService: PlatformService
    ) {}

    public getCategoryNavigationContent(path: string, params?: Params): Observable<UmbracoPage> {
        const state = this.transferState.get(categoryNavigationStateKey, null);

        if (state) {
            this.transferState.set(categoryNavigationStateKey, null);
            return of(state);
        }

        return this.http.get<UmbracoPage>(`content/page/${path}`, { params }).pipe(
            map(response => {
                if (this.platformService.isServer) {
                    this.transferState.set(categoryNavigationStateKey, response);
                }
                return response;
            })
        );
    }

    public getContent(path: string, params?: Params): Observable<UmbracoPage> {
        return this.http.get<UmbracoPage>(`content/page/${path}`, { params });
    }

    public getContentSearch(
        searchTerm: string,
        options?: {
            contentTypes?: string[];
            params?: Params;
        }
    ): Observable<SearchResultCmsPageViewModel[]> {
        const { contentTypes, params } = options || {};
        const requestUrl = `content/search?query=${searchTerm}${
            contentTypes?.length ? contentTypes.map(a => `&contentType=${a}`) : ''
        }`;
        const cacheKey = `${requestUrl}${params ? '?' : ''}${new URLSearchParams(params).toString()}`;

        if (this.contentCache[cacheKey]) {
            return of(this.contentCache[cacheKey]);
        }

        return this.http
            .get<SearchResultCmsPageViewModel[]>(requestUrl, { params })
            .pipe(tap(res => (this.contentCache[cacheKey] = res)));
    }
}
